/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Resume_StatusInputs */

const en_orders_resume_status = /** @type {(inputs: Orders_Resume_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Status`)
};

const es_orders_resume_status = /** @type {(inputs: Orders_Resume_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de reanudacion`)
};

/**
* | output |
* | --- |
* | "Resume Status" |
*
* @param {Orders_Resume_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_resume_status = /** @type {((inputs?: Orders_Resume_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Resume_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_resume_status(inputs)
	return es_orders_resume_status(inputs)
});